module.exports = __webpack_public_path__ + "media/28.112cef22.mp3";